module.exports = __webpack_public_path__ + "static/media/logo.b1bf7e1e.png";